import { render, staticRenderFns } from "./VacancyQuestionsList.vue?vue&type=template&id=60f5c0fe&scoped=true&"
import script from "./VacancyQuestionsList.vue?vue&type=script&lang=js&"
export * from "./VacancyQuestionsList.vue?vue&type=script&lang=js&"
import style0 from "./VacancyQuestionsList.vue?vue&type=style&index=0&id=60f5c0fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f5c0fe",
  null
  
)

/* custom blocks */
import block0 from "./VacancyQuestionsList.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=en"
if (typeof block0 === 'function') block0(component)
import block1 from "./VacancyQuestionsList.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=ru"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VList,VListItem,VListItemContent,VListItemGroup,VListItemIcon,VRow})
